import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  YAxis,
  Tooltip,
  XAxis,
  ResponsiveContainer,
} from "recharts";

const AgeComponent = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="stats-tooltip">
          <p className="label">Idade: {label}</p>
          <p className="label">Nº utilizadores: {payload[0].value}</p>
        </div>
      );
    }

    return null;
  };

  return data && data.ages ? (
    <div>
      Idades
      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={data.ages}>
          <Bar dataKey="age" fill="#366dc7" />
          <YAxis
            allowDecimals={false}
            tick={{ stroke: "white", strokeWidth: 0.5 }}
            label={{ angle: -90, position: "insideLeft" }}
          />
          <XAxis
            dataKey="idade"
            tickMargin="10"
            tick={{ stroke: "white", strokeWidth: 0.5 }}
          />
          <Tooltip content={<CustomTooltip />} cursor={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  ) : null;
};

export default AgeComponent;
